import "./index.css";
import { Link } from "react-router-dom";

export default function (props) {
    return (<Link to="/"><div className="gen-ai-icon-wrapper">
        <div className="gen-ai-icon-iMedical">iMedical </div>
        <div className="gen-ai-icon-search-wrapper" >
            <div className="gen-ai-icon-search">Search </div>
        </div>
    </div> </Link>);
}